import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import moment from "moment";

export default function AttendanceList() {
  const [lists, setLists] = useState([]);
  const [data, setData] = useState([]);
  const [filterValues, setFilterValues] = useState({
    month: new Date(),
  });
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const staffId = localStorage.getItem("staffId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  const resetForm = () => {
    setFilterValues({
      month: new Date(),
    });
    setLists([]);
  };
  const handleReset = () => {
    resetForm();
    GetData(pageNumber);
  };
  const handleSearch = () => {
    GetData(pageNumber);
  };
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    GetData(pageNumber);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETATTENDANCE +
          "?pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&staffId=" +
          staffId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  useEffect(() => {
    GetData(pageNumber);
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Attendance</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-lg-3">
                    <label> Month</label>
                    <div className="input-group">
                      <Flatpickr
                        value={filterValues.month}
                        className="form-control"
                        options={{
                          dateFormat: "Y-m",

                          plugins: [
                            new (require("flatpickr/dist/plugins/monthSelect"))(
                              {
                                shorthand: true,
                                dateFormat: "M-Y",
                                theme: "light",
                              }
                            ),
                          ],
                        }}
                        onChange={(date) =>
                          setFilterValues({ ...filterValues, month: date[0] })
                        }
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger ml-2"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Attendance Date</th>
                            <th>CheckIn</th>
                            <th>CheckOut</th>
                            <th>TotalHoursWorked</th>
                            <th>TotalOverTime</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.attendanceId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>
                                  {moment(v.attendanceDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                                </td>
                                <td>{moment(v.checkIn).format("hh:mm a")}</td>
                                <td>
                                  {v.checkOut === "0001-01-01T00:00:00"
                                    ? "--"
                                    : moment(v.checkOut).format("hh:mm a")}
                                </td>
                                <td>
                                  {Math.floor(v.totalWorkingHours)}h :
                                  {Math.round((v.totalWorkingHours % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}{" "}
                                  m
                                </td>
                                <td>
                                  {Math.floor(v.totalOverTime)}h :
                                  {Math.round((v.totalOverTime % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}{" "}
                                  m
                                </td>
                                <td
                                  style={{
                                    color:
                                      v.status === "CheckedIn"
                                        ? "red"
                                        : v.status === "CheckedOut"
                                        ? "green"
                                        : "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {v.status}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No attendance records found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}

                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
